import _typeof from "@babel/runtime/helpers/typeof";
import badgeMap from './badgeData.json';
export function getBadgeAriaLabels(badgeReferences) {
  if (!Array.isArray(badgeReferences)) {
    return [];
  } // Check if badgeReference already exists in badgeMap, if not sanitize and return


  return badgeReferences.filter(function (badgeReference) {
    return badgeReference && badgeReference.trim() !== '';
  }).map(function (badgeReference) {
    if (badgeReference in badgeMap) {
      return badgeMap[badgeReference]['aria-label'];
    }

    return badgeReference.replace(/_/g, ' ');
  });
}
export var getFirstBadgeValues = function getFirstBadgeValues(badgeData) {
  if (_typeof(badgeData) !== 'object' || !badgeData) {
    return [];
  } // Only return the first value of each badge as shown in UI


  return Object.values(badgeData).map(function (badgeArray) {
    if (badgeArray.length > 0) {
      return badgeArray[0];
    }

    return null;
  }).filter(Boolean);
};
export function generateBadgeAriaLabelString(badgeDataObject) {
  var firstBadgeValues = getFirstBadgeValues(badgeDataObject);
  var ariaLabels = getBadgeAriaLabels(firstBadgeValues);
  var nonEmptyAriaLabels = ariaLabels.filter(function (label) {
    return label.trim() !== '';
  });

  if (nonEmptyAriaLabels.length > 0) {
    return nonEmptyAriaLabels.join(', ');
  }

  return '';
}
export function generateAriaLabel() {
  var badge = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var featured = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var name = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var hasReviews = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var rating = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var reviewsCount = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var labels = [];

  if (typeof mto === 'boolean' && mto) {
    labels.push('Made to order');
  }

  if (typeof featured === 'boolean' && featured) {
    labels.push('Sponsored');
  }

  if (typeof name === 'string' && name.trim() !== '') {
    labels.push(name);
  }

  if (badge && _typeof(badge) === 'object') {
    labels.push(generateBadgeAriaLabelString(badge));
  }

  if (typeof hasReviews === 'boolean' && hasReviews) {
    if (typeof rating === 'number' && typeof reviewsCount === 'number') {
      labels.push("Rating ".concat(rating.toFixed(1), " out of 5, ").concat(reviewsCount, " ").concat(reviewsCount === 1 ? 'review' : 'reviews'));
    }
  }

  var nonEmptyLabels = labels.filter(function (label) {
    return label.trim() !== '';
  });
  var ariaLabel = nonEmptyLabels.join(', ');
  return ariaLabel;
}